var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current-screenshot"},[(_vm.activeScreenshots)?_c('div',{key:_vm.activeScreenshots.id,staticClass:"current-screenshot-frame",style:(_vm.tempStyle)},[_c('img',{attrs:{"src":_vm.activeScreenshots.image}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }